import { disableScroll, enableScroll } from './utilities'

export const initModal = () => {

  const globalSingleModal = document.querySelector('.modal[data-type="modal-single"')

  document.querySelectorAll('.modal')
    .forEach(function(el){
      el.addEventListener('click', function(event){
        if(event.target !== this)
          return
        hideModal(this)
      })
    })

  document.querySelectorAll('a[data-toggle^="close-modal"]')
    .forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        hideModal(el.closest('.modal'))
      })
    })

  document.querySelectorAll('a[data-toggle^="modal"]').forEach( el => modalLinkHandler(el) )

  if(globalSingleModal && globalSingleModal.dataset.postId){
    showModal(globalSingleModal)
  }
}

export const hideModal = modal => {
  if(modal){
    modal.classList.remove('show')
    enableScroll(modal.querySelector('.modal__content'))
    if(!document.querySelector('.modal.show')){
      document.body.removeChild(document.querySelector('.modal__backdrop'))
    }
  }
}

const modalLinkHandler = el => {
  if(!el.dataset.listener){
    el.dataset.listener = true

    el.addEventListener('click', (e) => {
      e.preventDefault()
      let modal = el.dataset.toggle
      if(modal == 'modal-single'){
        let postId = el.dataset.postId
        let postType = el.dataset.postType
        let blockId = el.dataset.blockId
        loadModal(e.target, modal, postType, postId, blockId)
        return
      }
      if(modal == 'modal-contact-form'){
        let el = document.querySelector('.modal[data-type="'+ modal +'"')
        showModal(el)
      }
    })
  }
}

const loadModal = (target, modal, postType, postId, blockId) => {
  let el = document.querySelector('.modal[data-type="'+ modal +'"')
  let url = '';
  let timerId = null;

  if( postType == 'block' ){
    url = `/wp-json/flexcon/v1/block/${postId}/${blockId}`
  }else{
    if(el.dataset.postId == postId){
      showModal(el)
      return
    }
    url = `/wp-json/wp/v2/${postType}/${postId}?acf_format=standard`
  }

  if(el){
    cleanModal(el)

    cleanLoader(timerId)
    timerId = setTimeout( () => {
      if (target.nodeName == "A"){
        target.classList.add('loading')
      }
    }, 1000)


    fetch(url)
    .then(response => response.json())
    .then(data => {
      let status = data.data && data.data.status
      if(status == "404") return

      let title = ``
      if( data.acf && data.acf.icon )
        title += `<img src="${data.acf.icon.url}" alt="${data.acf.icon.alt}" />`
      if(data.title.rendered)
        title += data.title.rendered

      fillModal(el, title, '' + data.content.rendered + '', postId)
      cleanLoader(timerId)
      showModal(el)
    })
    .catch((error) => {
      console.error('Error:', error);
      cleanLoader(timerId)
    });
  }
}

const showModal = modal => {
  if(modal){
    modal.querySelectorAll('a[data-toggle^="modal"]').forEach( el => modalLinkHandler(el))
    modal.classList.add('show')
    disableScroll(modal.querySelector('.modal__content'))
    if(!document.querySelector('.modal__backdrop')){
      let backdrop = document.createElement('div')
      backdrop.classList.add('modal__backdrop')
      document.body.appendChild(backdrop)
      requestAnimationFrame(() => {
        backdrop.classList.add('fade')
    })
    }
  }
}

const fillModal = (modal, title, body, postId) => {
  if(modal){
    if(postId) modal.setAttribute('data-post-id', postId)
    modal.querySelector('.modal__title').innerHTML = title
    modal.querySelector('.modal__body').innerHTML = body
  }
}

const cleanModal = modal => {
  if(modal){
    modal.removeAttribute('data-post-id')
    modal.querySelector('.modal__title').innerHTML = ''
    modal.querySelector('.modal__body').innerHTML = ''
  }
}

const cleanLoader = (timerId) => {
  if(typeof timerId !== 'undefined' && timerId !== null) clearTimeout(timerId)
  document.querySelectorAll('a.loading').forEach((el) => {
    el.classList.remove('loading')
  })
}